export default __webpack_public_path__ + "static/media/improve_your_upload.9220ce62.pdf";